import * as React from "react";
import {ContextProps, FeatureGroup, withLeaflet} from 'react-leaflet'
import * as L from 'leaflet';
import {LatLngBounds} from "leaflet";

interface ZoomingFeatureGroupProps extends ContextProps {
    zoomHook: any;
    enableAutoZoom: boolean;
}

const padding = L.point(50, 50);

class ZoomingFeatureGroup extends React.Component<ZoomingFeatureGroupProps> {
    private readonly ref: React.RefObject<FeatureGroup>;

    constructor(props: ZoomingFeatureGroupProps) {
        super(props);
        this.ref = React.createRef();
    }

    componentDidMount() {
        this.zoomToBounds();
    }

    zoomToBounds() {

        if (this.props.enableAutoZoom) {
            if (this.ref.current) {
                //const bounds = this.ref.current.leafletElement.getBounds();
                const bounds = this.getDeepBounds();
                if (bounds?.hasOwnProperty("_northEast")) {
                    this.props.leaflet.map.fitBounds(bounds, {padding: padding});
                }
            }
        }
    }

    getDeepBounds() {
        let bounds: LatLngBounds = null;
        let layers = this.extractLayers(this.ref.current.leafletElement.getLayers());

        layers
            .map(layer => {
                if ((layer as any)._bounds) {
                    return (layer as any)._bounds
                }
                return (layer as any)._latlng;
            })
            .filter(latlng => {
                return !!latlng
            })
            .forEach(latlng => {
                if (bounds) {
                    bounds.extend(latlng);
                } else {
                    bounds = new LatLngBounds(latlng);
                }
            });

        return bounds;
    }

    extractLayers(layers: L.Layer[]): L.Layer[] {
        let extracted: L.Layer[] = [];
        layers.forEach(layer => {
            extracted.push(layer);
            if ((layer as any).getLayers) {
                this.extractLayers((layer as any).getLayers())
                    .forEach(ll => extracted.push(ll));
            }
        });
        return extracted
    }

    componentDidUpdate(prevProps: Readonly<ZoomingFeatureGroupProps>) {
        if (this.props.enableAutoZoom) {
            if (this.props.zoomHook !== prevProps.zoomHook) {
                this.zoomToBounds();
            }
        }
    }

    render(): React.ReactNode {
        return <FeatureGroup ref={this.ref}>
            {this.props.children}
        </FeatureGroup>
    }
}

export default withLeaflet(ZoomingFeatureGroup);
